"use client";

import clsx from "clsx";
import React, { useState } from "react";

import { Box } from "@repo/ui/box";
import { Button } from "@repo/ui/button";
import * as Container from "@repo/ui/container";
import * as Flex from "@repo/ui/flex";
import { Text } from "@repo/ui/text";
import { STRINGS } from "@/constants";
import {
  TYPOGRAPHY_HEADING2,
  TYPOGRAPHY_BODY3_SENTENCE,
  TYPOGRAPHY_LINK2_CAPS,
} from "@/theme/topshop/typography/typography-constants";

import classes from "./content-seo.module.css";

type ContentSEOProps = {
  maxLines?: number;
  title?: string;
  body: React.ReactNode | string;
};

export const ContentSEO = ({ maxLines = 2, title, body }: ContentSEOProps) => {
  const [isOpen, toggle] = useState(false);

  return (
    <Container.Root size="large">
      <Box paddingX="3xl" paddingY="3xl">
        <Flex.Container column gap="2xs" className={classes.content}>
          <Text className={TYPOGRAPHY_HEADING2}>{title}</Text>
          <Text
            className={TYPOGRAPHY_BODY3_SENTENCE}
            maxLines={isOpen ? undefined : maxLines}
          >
            {body}
          </Text>
        </Flex.Container>
        <Button
          onClick={() => toggle(!isOpen)}
          aria-expanded={isOpen}
          className={clsx(TYPOGRAPHY_LINK2_CAPS, classes.button)}
        >
          {isOpen
            ? STRINGS.productListing.readLess
            : STRINGS.productListing.readMore}
        </Button>
      </Box>
    </Container.Root>
  );
};
